import { render, staticRenderFns } from "./DerivacionModalView.vue?vue&type=template&id=10f36174"
import script from "./DerivacionModalView.vue?vue&type=script&lang=js"
export * from "./DerivacionModalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports